import { useEffect, useState } from "react";
import { Button, Col, Row, Table } from "antd";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { service } from "../services/service";

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Surname",
    dataIndex: "surname",
    key: "surname",
  },
  {
    title: "Agency",
    dataIndex: "agency",
    key: "agency",
  },
];

function getDate() {
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  return `${date}_${month}_${year}`;
}

function TableCostumers() {
  const [tableValue, setTableValue] = useState();
  const [currentDate] = useState(getDate());

  useEffect(() => {
    const loggedStorage = localStorage.getItem("user");
    if (loggedStorage === null) {
      window.location.assign("/login");
    }
  }, []);

  useEffect(() => {
    getTable();
  }, []);

  function getTable() {
    const role = localStorage.getItem("role");
    let temp = [];
    let i, k;
    service.getCostumerTable().then((res) => {
      for (i = 0; i < res.length; i++) {
        for (k = 0; k < res[i].player_roles_id.length; k++) {
          if (role === res[i].player_roles_id[k].name) {
            temp.push(res[i]);
          }
        }
      }
      setTableValue(temp);
    });
  }

  function saveExel() {
    const worksheet = XLSX.utils.json_to_sheet(tableValue);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Buffer to store the generated Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, `costumer_${currentDate}.xlsx`);
  }

  return (
    <>
      <Row justify="end">
        <Col span={6}>
          <h1 style={{ margin: 0 }}>Costumers</h1>
        </Col>
        <Col span={3} offset={15} style={{ textAlign: "end" }}>
          <Button
            type="primary"
            onClick={() => saveExel()}
            style={{ marginBottom: "10px" }}
          >
            Export
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableValue}
            pagination={{ defaultCurrent: 1, pageSize: 8 }}
          />
        </Col>
      </Row>
    </>
  );
}
export default TableCostumers;
